// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contacts_wrapper__2Cp5S","menu":"Contacts_menu__3ICXA","icon":"Contacts_icon__3Hz7i"};